<template>
  <v-app id="inspire"> 
    <mo-header></mo-header>
    <v-content>
		<tender-head></tender-head>		
		<tender-list></tender-list>
    </v-content>
  </v-app>
</template>

<script>

	import TenderHead from './Header.vue';	
	import TenderList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			TenderHead,
			TenderList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>